
import React from "react";
import "./RudrakshaVideos.css";

import video1 from "../../assets/images/product-video1.mp4";
import video2 from "../../assets/images/product-video2.mp4";
import video3 from "../../assets/images/product-video3.mp4";
import video4 from "../../assets/images/product-video4.mp4";
import video5 from "../../assets/images/product-video5.mp4";

import wearImg from "../../assets/images/pro2.webp";
import careImg from "../../assets/images/pro3.webp";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const videos = [
  {
    id: 1,
    video: video1,
    title: "Rudrakshas",
  },
  {
    id: 2,
    video: video2,
    title: "Gemstones",
  },
  {
    id: 3,
    video: video3,
    title: "Crystals & Healing Stones",
  },
  {
    id: 4,
    video: video4,
    title: "Conch Shells & Shaligrams",
  },
  {
    id: 5,
    video: video5,
    title: "Vastu Products",
  },
];

export default function RudrakshaVideos() {
  return (
    <>
      {/* Rudraksha Wear & Care Guide */}

      <section className="guide-section">
        <div className="guide-grid">

          {/* Wear Guide Text */}
          <div className="guide-card text-card">
            <h2>Rudraksha Wear Guide</h2>

            <div className="guide-list">

              <div className="guide-item">
                <span>✦</span>
                <p>
                  <strong>Purify Before Wearing:</strong>
                  <br />
                  Soak in raw milk and wash with clean water.
                </p>
              </div>

              <div className="guide-item">
                <span>✦</span>
                <p>
                  <strong>Wear on Monday:</strong>
                  <br />
                  Chant "Om Namah Shivaya" before wearing.
                </p>
              </div>

              <div className="guide-item">
                <span>✦</span>
                <p>
                  <strong>Avoid Impurities:</strong>
                  <br />
                  Keep away from alcohol and non-veg food.
                </p>
              </div>

              <div className="guide-item">
                <span>✦</span>
                <p>
                  <strong>Use Proper Thread:</strong>
                  <br />
                  Wear with silk thread or silver/gold chain.
                </p>
              </div>

            </div>
          </div>

          {/* Wear Guide Image */}
          <div className="guide-card image-card">
            <img src={wearImg} alt="Rudraksha Wear Guide" />
          </div>

          {/* Care Guide Image */}
          <div className="guide-card image-card">
            <img src={careImg} alt="Rudraksha Care Guide" />
          </div>

          {/* Care Guide Text */}
          <div className="guide-card text-card">
            <h2>Rudraksha Care Guide</h2>

            <div className="guide-list">

              <div className="guide-item">
                <span>❤</span>
                <p>
                  <strong>Keep Dry</strong>
                  <br />
                  Avoid soap, shampoo and chemicals.
                </p>
              </div>

              <div className="guide-item">
                <span>❤</span>
                <p>
                  <strong>Clean Regularly</strong>
                  <br />
                  Wipe using a soft cotton cloth.
                </p>
              </div>

              <div className="guide-item">
                <span>❤</span>
                <p>
                  <strong>Store Safely</strong>
                  <br />
                  Keep in a sacred clean place.
                </p>
              </div>

              <div className="guide-item">
                <span>❤</span>
                <p>
                  <strong>Avoid Rough Handling</strong>
                  <br />
                  Protect from cracks and damage.
                </p>
              </div>

            </div>
          </div>

        </div>
      </section>


      {/* Sacred Collection Videos */}

      <section className="video-section">
        <div className="container">

          <h2 className="video-heading">
            Explore Our Sacred Collection
          </h2>

          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>

          <br />

          <p className="video-subtitle">
            Discover thoughtfully selected spiritual treasures, crafted
            to bring meaning, beauty, and positive energy into your journey.
          </p>

          <br />

          {/* Desktop Video Grid */}

          <div className="video-grid video-desktop">
            {videos.map((item) => (
              <div className="video-card" key={item.id}>
                <video
                  src={item.video}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                />

                <h4>{item.title}</h4>
              </div>
            ))}
          </div>


          {/* Mobile Video Slider */}

          <div className="video-mobile-slider">

            <Swiper
              modules={[Pagination]}
              slidesPerView={1.2}
              spaceBetween={15}
              loop={true}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                400: {
                  slidesPerView: 1.3,
                },
                480: {
                  slidesPerView: 1.5,
                },
              }}
            >
              {videos.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="video-card">

                    <video
                      src={item.video}
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="metadata"
                    />

                    <h4>{item.title}</h4>

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

          </div>

        </div>
      </section>

    </>
  );
}
